import { BlockDefinitionArray } from '@longy/common/cms'

export type ProgramCardContent = { hasBody: boolean; hasDetails: boolean }

/**
 * What a program card shows, and whether its details link leads anywhere.
 *
 * The card body renders the compact subset of the blocks — text and image only — while the details
 * page renders all of them, so the two questions have different answers: a program whose content is
 * one FAQ block has nothing to put on the card but a page worth linking to. Offering the link
 * regardless is the failure that matters, because it lands the visitor on an empty page.
 */
export const resolveProgramCardContent = ({
    compactBlocks,
    blocks,
    descriptionHtml,
}: {
    compactBlocks: BlockDefinitionArray
    blocks: BlockDefinitionArray
    descriptionHtml: string
}): ProgramCardContent => {
    const hasDescription = descriptionHtml.trim() !== ''

    return {
        hasBody: compactBlocks.length > 0 || hasDescription,
        hasDetails: blocks.length > 0 || hasDescription,
    }
}
